<template>
  <v-card class="elevation-0 px-0">
    <v-card-text class="px-0">
      <v-row class="mb-1 ta-center">
        <v-col>
          <div class="c-dark-blue fs-18 fw-500 mb-1">We’ll find providers convenient to your location</div>
          <div class="c-dark-blue fs-26 fw-600 mb-2">Where do you want to focus your search?</div>
        </v-col>
      </v-row>

      <v-row class="justify-center mb-0">
        <v-col>
          <v-radio-group class="mt-0 ta-center mx-auto" row="" v-model="search.location_type">
            <v-radio label="Home" value="home"></v-radio>
            <v-radio label="Work" value="work"></v-radio>
            <v-radio label="Along My Commute" value="commute"></v-radio>
            <v-radio label="Other" value="other"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="pb-0">
          <v-text-field class="c-dark-blue fs-18 mt-0 pl-2" id="search_origin_address" label="Address or neighborhood" outlined="" placeholder="Enter a location" ref="origin_autocomplete" v-model="search.formatted_origin"></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="search.location_type == 'commute'">
        <v-col class="pb-0">
          <v-text-field class="c-dark-blue fs-18 mt-0 pl-2" id="search_destination_address" label="Commute destination" outlined="" placeholder="Enter a location" ref="destination_autocomplete" v-model="search.formatted_destination"></v-text-field>
        </v-col>
      </v-row>

      <v-row class="justify-center mb-4" v-if="search.location_type == 'commute'">
        <v-col class="pt-0 ta-center">
          <v-btn-toggle borderless="" rounded="" v-model="search.travel_mode">
            <v-btn value="DRIVING">
              <v-icon>directions_car</v-icon>
            </v-btn>
            <v-btn value="TRANSIT">
              <v-icon>directions_transit</v-icon>
            </v-btn>
            <v-btn value="BICYCLING">
              <v-icon>directions_bike</v-icon>
            </v-btn>
            <v-btn value="WALKING">
              <v-icon>directions_walk</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {

  data: function() {
    return {
      destinationAutocomplete: {},
      originAutocomplete: {},
    }
  },

  methods: {
    setDestination: function() {
      let place = this.destinationAutocomplete.getPlace();
      this.search.formatted_destination = place.formatted_address
      let parts = place.formatted_address.split(",")
      let state_zip = parts[parts.length - 2].split(" ")
      this.search.destination = {
        name: 'Work',
        address: parts[0],
        city: parts[parts.length - 3],
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
        place_id: place.place_id,
        state: state_zip[1],
        zip: state_zip[2],
      }
    },

    setOrigin: function() {
      let place = this.originAutocomplete.getPlace();
      this.search.formatted_origin = place.formatted_address
      let parts = place.formatted_address.split(",")
      let state_zip = parts[parts.length - 2].split(" ")
      this.search.origin = {
        name: 'Home',
        address: parts[0],
        city: parts[parts.length - 3],
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
        state: state_zip[1],
        zip: state_zip[2],
      }
    }
  },

  mounted: function() {
    this.originAutocomplete = new window.google.maps.places.Autocomplete(this.$refs.origin_autocomplete.$refs.input, { types: ['geocode'] });
    this.originAutocomplete.addListener('place_changed', this.setOrigin)
  },

  props: ['search'],

  watch: {
    // This exists because destination is hidden at first render - something necessary only because a Vuetify bug that causes the outlined label to break when v-show is used instead of v-if
    'search.location_type'(newVal) {
      if(newVal == 'commute') {
        var vm = this
        setTimeout(function() {
          vm.destinationAutocomplete = new window.google.maps.places.Autocomplete(vm.$refs.destination_autocomplete.$refs.input, { types: ['geocode'] });
          vm.destinationAutocomplete.addListener('place_changed', vm.setDestination)
        }, 100)
      }
    }
  }
}
</script>

